<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <hm-alert />
        <p>A business associate (BA) is a person or entity that performs a service on your behalf involving the use or disclosure of protected health information. Examples include&#58;</p>
        <ul>
          <li>Clearinghouse</li>
          <li>Email or text messaging services</li>
          <li>Electronic health record (EHR) vendors</li>
          <li>Patient scheduling services</li>
          <li>Electronic phone or fax services</li>
          <li>E-prescribing gateway</li>
          <li>Patient billing services</li>
          <li>Legal, accounting or administrative services</li>
        </ul>
        <p>
          What if you are the BA for another covered entity?
          <hm-popover title="Are you a BA?">
            <div>If your practice is the business associate of another covered entity and your practice has subcontractors performing activities to help carry out the activities you have agreed to carry out for the covered entity, your practice must require these subcontractors to provide satisfactory assurances for the protection of the ePHI. In other words, add your subcontractors as business associates in HIPAAMATE and obtain signed agreements from them.</div>
          </hm-popover>
        </p>
        <hm-spinner v-if="!ready" />
      </b-col>
    </b-row>

    <b-row v-show="ready">
      <b-col>
        <b-button type="button" variant="primary" class="px-4" to="/ba-edit">Add Business Associate</b-button>
      </b-col>
    </b-row>

    <b-row class="pt-4" v-show="ready">
      <b-col>
        <b-table class="p-1" responsive bordered hover show-empty empty-text="Add at least one BA" :items="ba" :fields="columns" @row-clicked="rowClick">
          <template slot="cell(name)" slot-scope="data">
            <div class="ba-name">{{data.value}}</div>
          </template>
          <template slot="cell(phone)" slot-scope="data">
            <div class="nowrap">{{data.value|tel}}</div>
          </template>
          <template slot="cell(access)" slot-scope="data">
            <span class="ba-access column-min-width">{{data.value}}</span>
          </template>
          <template slot="cell(signed)" slot-scope="data">
            <span v-if="data.value">
              <i class="icon-check text-success pr-2"></i>Yes
            </span>
            <span v-else>
              <i class="icon-exclamation text-danger pr-2"></i>No
            </span>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { practiceService } from '@/services'

export default {
  name: 'BAList',
  data() {
    return {
      ba: [],
      columns: [{
        key: 'name',
        label: 'Name',
        sortable: true
      }, {
        key: 'phone',
        label: 'Phone'
      }, {
        key: 'email',
        label: 'Email'
      }, {
        key: 'access',
        label: 'Access'
      }, {
        key: 'signed',
        label: 'Signed'
      }],
      ready: false
    }
  },
  methods: {
    ...mapActions({
      alertException: 'alert/exception'
    }),
    rowClick(record, index) {
      this.$router.push({ name: 'BAEdit', params: { id: record.id } });
    }
  },
  created() {
    this.ready = false;

    practiceService.getBA()
      .then(data => {
        this.ba = data;
      })
      .catch(err => {
        this.alertException({ err, message: 'Error loading business associates.' });
      }).finally(() => {
        this.ready = true;
      })
  }
}
</script>

<style scoped>
.ba-name {
  min-width: 130px;
}
.ba-access {
  white-space: pre-wrap;
  display: inline-block;
}
.column-min-width {
  min-width: 250px;
}
</style>